<template>
    <NuxtLink
        aria-label="GROWNi"
        class="CLogo"
        :class="{ 'mobile-small flex items-center': smallOnMobile }"
        to="/"
    >
        <!-- Inlined (not <img>) so the logo takes the link's text color via currentColor -->
        <span
            class="block [&>svg]:size-full"
            :class="smallOnMobile ? 'hidden h-4 w-[84px] sm:block' : 'h-5 w-[105px]'"
            v-html="logoSvg"
        />
        <span v-if="smallOnMobile" class="block size-[26px] sm:hidden [&>svg]:size-full" v-html="markSvg" />
    </NuxtLink>
</template>

<script setup lang="ts">
import logoSvg from '@/assets/brand/growni-logo.svg?raw'
import markSvg from '@/assets/brand/growni-mark.svg?raw'

defineProps({
    smallOnMobile: {
        type: Boolean,
        default: false
    }
})
</script>
